// import { VkErrorTypes } from "@happysanta/bridge-plus";

const getErrorStatus = (error) => {
    if( error === 'offline'
    ||  error.type === 'network_error' 
    || error.message ==='Network Error' )
    return { errorStatus: 'Network Error' }  
}
 
export default getErrorStatus;